<!-- Top bar -->
<mat-toolbar class="topBar">

  <!-- Back to Home -->
  <button mat-mini-fab
          class="example-icon"
          type="button"
          aria-label="Example icon-button with menu icon"
          matTooltip="Back to Home"
          matTooltipPosition="below"
          (click)="router.navigate(['menu'])">
    <mat-icon>
      arrow_back
    </mat-icon>
  </button>

  <!-- Back to Home -->
  <button mat-mini-fab
          class="example-icon"
          style="margin-left: 20px"
          type="button"
          matTooltip="Back to Home"
          matTooltipPosition="below"
          (click)="router.navigate(['menu'])">
    <mat-icon>
      home
    </mat-icon>
  </button>

  <!-- Page title -->
  <span class="settings-title">
    Settings
  </span>

  <span class="spacer"></span>

  <mat-spinner *ngIf="dataSync.sync_in_progress()" [diameter]="35" class="mat-spinner-color"></mat-spinner>
</mat-toolbar>

<div class="container help-container">

  <div class="row" style="margin-left: 0px; margin-right: 0px; border: 1px solid; border-radius: 8px; padding: 5px; margin-top: 10px; background-color: var(--elog-card-bg);">
    <h2 style="margin-bottom: 0px;">Last Successful Sync: {{syncDate()}}</h2>
  </div>

  <!-- Check for app update -->
  <div style="display: flex;">

      <button mat-flat-button
            class="text-button-cyan"
            style="margin-right: 15px"
            type="button"
            (click)="checkForUpdate()">
        Check for Updates
      </button>

      <button mat-flat-button
          class="text-button-cyan"
          type="button"
          (click)="performDataSync()">
        Sync my Data
      </button>

  </div>



  <!-- Vessels -->
  <!-- "My Vessels" -->
  <div class="row">
    <h1 class="settings-h1">
      My Vessels
    </h1>
    <small class="text-muted settings-small">
      View, Add, and Edit Vessels
    </small>
  </div>

  <!-- Vessel list -->
  <div class="row">
    <mat-selection-list #vessels
                        hideSingleSelectionIndicator="true"
                        [multiple]="false">
      <mat-divider></mat-divider>
      <div *ngFor="let vessel of operatedVessels(); let index=index;">
        <mat-list-option (click)="editVessel(index)">
          <span class="list-item">
            {{vessel.vesselName}} - {{vessel.vesselCoastNumber}}
          </span>
        </mat-list-option>
        <mat-divider></mat-divider>
      </div>
    </mat-selection-list>
  </div>

  <!-- Add a new vessel -->
  <div class="row">
    <div class="col-6">
      <button mat-stroked-button
              class="text-button"
              type="button"
              (click)="addVessel()">
        Add New Vessel
      </button>
    </div>
  </div>

  <!-- Favorite Species -->
  <!-- "My Favorite Species" -->
  <div class="row">
    <h1 class="settings-h1">
      My Favorite Species
    </h1>
    <small class="text-muted settings-small">
      View, Add, and Edit Species
    </small>
  </div>

  <!-- Favorite Species list -->
  <div class="row">
    <mat-selection-list [multiple]="false" hideSingleSelectionIndicator="true">
      <mat-divider></mat-divider>
      <div *ngFor="let species of favSpeciesList(); let index=index;">
        <mat-list-option (click)="editSpecies(index)">
          <span class="list-item">
            {{species.name}}
          </span>
        </mat-list-option>
        <mat-divider></mat-divider>
      </div>
    </mat-selection-list>
  </div>

  <!-- Add a new species -->
  <div class="row">
    <div class="col-6">
      <button mat-stroked-button
              class="text-button"
              type="button"
              (click)="addSpecies()">
        Add New Species
      </button>
    </div>
  </div>

  <!-- Fisheries -->
  <!-- "My Fisheries" -->
  <div class="row">
    <h1 class="settings-h1">
      My Fisheries
    </h1>
    <small class="text-muted settings-small">
      View, Add, and Edit Fisheries
    </small>
  </div>

  <!-- Fishery list HMS Hidden -->
  <div class="row">
    <mat-selection-list [multiple]="false" hideSingleSelectionIndicator="true">
      <mat-divider></mat-divider>
      <div *ngIf="dataSync.current_user().groundfishFishery">
        <mat-list-option (click)="addRemoveFishery()">
          <span class="list-item">
            Groundfish Non-Trawl
          </span>
        </mat-list-option>
        <mat-divider></mat-divider>
      </div>
      <div *ngIf="dataSync.current_user().hmsFishery">
        <mat-list-option (click)="addRemoveFishery()">
          <span class="list-item">
            HMS
          </span>
        </mat-list-option>
        <mat-divider></mat-divider>
      </div>
      <div *ngIf="dataSync.current_user().trawlFishery">
        <mat-list-option (click)="addRemoveFishery()">
          <span class="list-item">
            Trawl
          </span>
        </mat-list-option>
        <mat-divider></mat-divider>
      </div>
    </mat-selection-list>
  </div>

  <!-- Add a Fishery -->
  <div class="row">
    <div class="col-6">
      <button mat-stroked-button
              class="text-button"
              type="button"
              (click)="addRemoveFishery()">
        Add Fishery
      </button>
    </div>
  </div>

  <!-- Gears -->
  <!-- "My Gears" -->
  <div class="row" *ngIf="dataSync.current_user().groundfishFishery">
    <h1 class="settings-h1">
      My Gears
    </h1>
    <small class="text-muted settings-small">
      View, Add, and Edit Gears
    </small>
  </div>

  <!-- Gears list -->
  <div class="row" *ngIf="dataSync.current_user().groundfishFishery">
    <mat-selection-list [multiple]="false" hideSingleSelectionIndicator="true">
      <mat-divider></mat-divider>
      <div *ngFor="let gear of dataSync.user_gear(); let index=index;">
        <mat-list-option (click)="editGear(index)">
          <span class="list-item">
            {{gear}}
          </span>
        </mat-list-option>
        <mat-divider></mat-divider>
      </div>
    </mat-selection-list>
  </div>

  <!-- Add a new gear -->
  <div class="row" *ngIf="dataSync.current_user().groundfishFishery">
    <div class="col-6">
      <button mat-stroked-button
              class="text-button"
              type="button"
              (click)="addGear()">
        Add New Gear
      </button>
    </div>
  </div>

</div>
